module.exports = __webpack_public_path__ + "img/clouds-sun-2.f1184494.svg";